import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchResult } from '@core/services/api/header.service';

@Component({
  selector: 'app-search-popup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './search-popup.component.html',
  styleUrl: './search-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchPopupComponent {
  @Input() results: SearchResult[] = [];
  @Input() isLoading: boolean = false;
  @Input() searchQuery: string = '';
  @Input() totalResults: number = 0;
  
  @Output() closePopup = new EventEmitter<void>();
  @Output() resultClick = new EventEmitter<SearchResult>();
  @Output() searchChange = new EventEmitter<string>();

  handleSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.searchChange.emit(target.value);
  }

  handleResultClick(result: SearchResult): void {
    this.resultClick.emit(result);
  }

  handleClose(): void {
    this.closePopup.emit();
  }

  getResultIcon(type: string): string {
    switch (type) {
      case 'user':
        return 'pi pi-user';
      case 'rca':
        return 'pi pi-file';
      case 'response':
        return 'pi pi-reply';
      default:
        return 'pi pi-info-circle';
    }
  }

  getResultTypeLabel(type: string): string {
    switch (type) {
      case 'user':
        return 'User';
      case 'rca':
        return 'RCA';
      case 'response':
        return 'Response';
      default:
        return '';
    }
  }

  // Strip HTML tags from description for display
  stripHtml(html: string): string {
    if (!html) return '';
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  // Truncate text to a maximum length
  truncate(text: string, maxLength: number = 100): string {
    if (!text) return '';
    const stripped = this.stripHtml(text);
    return stripped.length > maxLength ? stripped.substring(0, maxLength) + '...' : stripped;
  }
}
